import { render, staticRenderFns } from "./subsidiary.vue?vue&type=template&id=39c5d798"
import script from "./subsidiary.vue?vue&type=script&lang=js"
export * from "./subsidiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports